import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15.21 18"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m14.11 15.03-3.78-3.68c.85-.95 1.38-2.18 1.38-3.55 0-1.29-.46-2.48-1.22-3.4A5.354 5.354 0 0 0 1 7.81c0 1.24.42 2.38 1.14 3.29a5.361 5.361 0 0 0 4.22 2.06c1.37 0 2.61-.53 3.55-1.38l3.78 3.68c.06.06.13.08.21.08.08 0 .16-.03.21-.09a.29.29 0 0 0 0-.42zM1.6 7.81c0-1.26.5-2.42 1.3-3.27.87-.92 2.1-1.49 3.45-1.49 1.31 0 2.5.53 3.36 1.39.86.86 1.39 2.05 1.39 3.36s-.53 2.5-1.39 3.36c-.86.86-2.05 1.39-3.36 1.39s-2.5-.53-3.36-1.39A4.698 4.698 0 0 1 1.6 7.81z"
    }, null, -1)
  ])))
}
export default { render };